module.exports = __webpack_public_path__ + "img/free with this tutor_sCN.4f437ecb.png";